import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StudentList from "./StudentList";
import { fetchStudents } from "../pages/services/studentService";
// import "../styles/BatchList.css";

const AllStudent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [students, setStudents] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // You can change this dynamically

  // Show success message if passed via location.state
  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      setShowSuccessMessage(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, location.pathname, navigate]);

  // Auto-hide success message
  useEffect(() => {
    if (showSuccessMessage) {
      const timer = setTimeout(() => {
        setShowSuccessMessage(false);
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessMessage]);

  // Fetch batches based on current page and pageSize
  useEffect(() => {
    const getStudents = async () => {
      try {
        setLoading(true);
        const fetchedData = await fetchStudents(page, pageSize, "studentName", "asc");
        setStudents(fetchedData.data);
        setPagination(fetchedData.pagination);
      } catch (error) {
        setError("Error fetching batches");
      } finally {
        setLoading(false);
      }
    };
    getStudents();
  }, [page, pageSize]);

  if (loading) {
    return (
      <div className="overlay">
        <div className="custom-loader"></div>
        <p className="loading-text">Loading...</p>
      </div>
    );
  }

  if (error) {
    return <p className="error-text">{error}</p>;
  }

  return (
    <div>
      {showSuccessMessage && <div className="success-toast">{successMessage}</div>}
      <StudentList
        students={students}
        pagination={pagination}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  );
};

export default AllStudent;
